import React from 'react';
import { Box, Divider, Paper, Typography } from '@mui/material';

// 메인화면 카드 비주얼 리뉴얼(2026-10-23) - 흰 배경 + 옅은 테두리 + 작은 radius,
// 어두운 제목바 없음. components/common/template/DetailTemplate.js(검은 제목바)는
// 폼/상세화면 등 전체 앱에서 100곳 가까이 쓰이고 있어 그대로 두고, 홈 위젯 전용으로
// 이 카드를 새로 둔다 - 블라스트 radius를 홈 화면으로만 좁히는 의도적 선택.
//
// title/subtitle은 좌상단, action(보통 "전체 보기 →")은 우상단, footer는 작은
// 회색 글씨(예: "14:30 기준")로 카드 아래쪽에 둔다.
const WidgetCard = ({ title, subtitle, action, footer, dense = false, children, sx = {} }) => (
  <Paper
    variant="outlined"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      borderRadius: 1.5,
      borderColor: 'divider',
      bgcolor: 'background.paper',
      ...sx,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 1,
        px: 2,
        pt: 1.5,
        pb: subtitle ? 0.5 : 1,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="subtitle2" component="div" sx={{ fontWeight: 600, lineHeight: 1.3 }} noWrap>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.25 }} noWrap>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && <Box sx={{ ml: 1, flexShrink: 0 }}>{action}</Box>}
    </Box>
    <Divider />
    <Box sx={{ px: 2, py: dense ? 1 : 1.5, flex: 1, minWidth: 0 }}>{children}</Box>
    {footer && <Box sx={{ px: 2, pb: 1 }}>{footer}</Box>}
  </Paper>
);

export default WidgetCard;
